import { cn } from '@repo/ui';
import type { ReactElement, ReactNode } from 'react';

interface EyebrowLabelProps {
  readonly children: ReactNode;
  /** 제목 앞 짧은 라임 선 — 화면을 여는 머리말에만 단다. */
  readonly accent?: boolean;
  readonly className?: string;
}

/** 작은 영문 머리말(예: COLOR · QUANTITY) — 회사 소개 머리말과 같은 넓은 자간의 대문자. 장식이라 낭독기에서는 숨긴다. */
export const EyebrowLabel = ({
  children,
  accent = false,
  className,
}: EyebrowLabelProps): ReactElement => (
  <p
    aria-hidden
    className={cn(
      'flex items-center gap-2 text-[11px] leading-none font-semibold tracking-[0.18em] text-muted-foreground uppercase',
      className,
    )}
  >
    {accent && <span className="block h-px w-6 bg-brand-lime" />}
    {children}
  </p>
);
